import * as T_T from 'cryface';
import { cloneDeep } from 'lodash';
import { HybridShareCommunityI18n } from '../hybrid.share.community.i18n';

export function hybridShareCommunityMaritalOptions(vs: any, locale: any) {
    const sum = T_T.sum(vs.Data.filter((v: any) => {
        return v['Key'].indexOf('living common law') === -1;
    }).map((v: any) => (Number(v['Value']))));
    const data: any = vs.Data.map((v: any) => ({
        name: `${v['Key']}`,
        value: Number(v['Value']),
        title: `${v['Key']}`,
        share: Math.round(Number(v['Value']) / sum * 10000) / 100
    })).filter((v: any) => {
        return v.name.indexOf('living common law') === -1;
    }).sort((a: any, b: any) => a.value - b.value);
    const legend = data.map((v: any) => (`${HybridShareCommunityI18n.translate(v.name, locale)}`));
    const max = cloneDeep(data).sort((a: any, b: any) => b.value - a.value);
    const xValue = data.map((v: any) => (v.value));
    let story = '';
    data.map((v: any) => {
        if (v.value / sum > 0.3) {
            story = `Most of people are ${v.name.toLowerCase()}.`;
        }
    });
    const options = {
        rifoStory: {
            title: vs['Name'],
            value: `${Math.round(max[0]['share'] + max[1]['share'])}%`
        },
        color: ['#009abf'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        grid: {
            left: '0%',
            right: '5%',
            bottom: '3%',
            top: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'value',
                max: max[0].value + Math.round(max[0].value * 0.3),
            }
        ],
        yAxis: [
            {
                type: 'category',
                data: legend,
                // axisTick: {
                //     alignWithLabel: true
                // }
                axisLabel: {
                    show: true,
                    fontSize: 10,
                    interval: 0,
                },
            },
        ],
        series: [
            {
                name: 'Value',
                type: 'bar',
                barWidth: '60%',
                data: xValue,
                z: 3,
                label: {
                    normal: {
                        position: 'right',
                        show: true
                    }
                },
            }
        ]
    };
    return options;
}
